import { render, staticRenderFns } from "./LoginLogFunction.vue?vue&type=template&id=478c90b1"
import script from "./LoginLogFunction.vue?vue&type=script&lang=js"
export * from "./LoginLogFunction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports